<template>
  <div class="w-11/12 mx-auto pt-10" :class="{ 'iframe-mode': isInIframe }">
    <div class="text-zt-xl" :class="primaryTextClass">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <button
            class="h-8 w-8 back-button"
            @click="goBack()"
            v-on="on"
            data-vs-button="toLicenceManager"
          >
            <zt-icon name="arrow-left" class="pb-2 mt-1 pr-1" />
          </button>
        </template>
        <span>{{ $t('message.LicensesManager.goBack') }}</span>
      </v-tooltip>
      <span class="ml-1">{{ $t('message.LicensesManager.search.title') }}</span>
    </div>
    <div class="mt-3 flex flex-wrap w-full pb-4">
      <div class="w-3/12 pr-4">
        <v-card>
          <v-card-text>
            <div class="w-full">
              <template v-if="currentTab === 'licenses'">
                <div>
                  <v-autocomplete
                    :key="`user-autocomplete-${currentTab}`"
                    v-model="userSelected"
                    :items="items"
                    :loading="usersLoading"
                    :search-input.sync="searchUsers"
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="id"
                    :label="$t('message.LicensesManager.search.user')"
                    :hint="$t('message.LicensesManager.search.userHint')"
                    persistent-hint
                    return-object
                    outline
                    color="#4f41a3"
                    clearable
                    data-vs-autocomplete="user"
                  ></v-autocomplete>
                </div>
                <div class="mt-2">
                  <v-select
                    class="selectLicenseProperty"
                    item-text="value"
                    item-value="id"
                    :items="estados"
                    v-model="estadoSelected"
                    return-object
                    :label="$t('message.LicensesManager.search.status')"
                    outline
                    :color="primaryColor"
                    clearable
                    data-vs-select="status"
                    :no-data-text="$t('message.datatable.noDataText')"
                  ></v-select>
                </div>
                <div>
                  <v-select
                    class="selectLicenseProperty"
                    item-text="nombre"
                    item-value="id"
                    :items="licenseTypes"
                    v-model="licenseTypeSelected"
                    return-object
                    :label="$t('message.LicensesManager.search.type')"
                    outline
                    :color="primaryColor"
                    clearable
                    data-vs-select="licenceType"
                    :no-data-text="$t('message.datatable.noDataText')"
                  ></v-select>
                </div>
                <div>
                  <v-select
                    class="selectLicenseProperty"
                    item-text="value"
                    item-value="id"
                    :items="estadosUsuario"
                    :value="estadosUsuario.id"
                    v-model="estadoUsuarioSelected"
                    return-object
                    :label="$t('message.LicensesManager.search.userStatus')"
                    outline
                    :color="primaryColor"
                    data-vs-select="userStatus"
                    :no-data-text="$t('message.datatable.noDataText')"
                  ></v-select>
                </div>
                <div>
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    full-width
                    nudge-left="20"
                    nudge-bottom="5"
                    lazy
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :label="$t('message.LicensesManager.search.fromPeriod')"
                        :value="formatedDateFrom"
                        append-icon="event"
                        @click:append="menu1 = true"
                        readonly
                        v-on="on"
                        outline
                        :color="primaryColor"
                        clearable
                        @click:clear="fixDatePickerClearBug('periodoDesde')"
                        data-vs-textfield="formatedDateFrom"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :locale="vuetifyLocale"
                      v-model="periodoDesde"
                      no-title
                      @input="menu1 = false"
                      event-color="primary"
                      data-vs-datepicker="formatedDateFrom"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    full-width
                    nudge-left="20"
                    nudge-bottom="5"
                    lazy
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :label="$t('message.LicensesManager.search.toPeriod')"
                        :value="formatedDateTo"
                        append-icon="event"
                        @click:append="menu2 = true"
                        readonly
                        v-on="on"
                        outline
                        :color="primaryColor"
                        clearable
                        @click:clear="fixDatePickerClearBug('periodoHasta')"
                        data-vs-textfield="formatedDateTo"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :locale="vuetifyLocale"
                      v-model="periodoHasta"
                      no-title
                      @input="menu2 = false"
                      event-color="primary"
                      data-vs-datepicker="formatedDateTo"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div v-if="config.periodo_liquidacion">
                  <v-menu
                    v-model="menu3"
                    :close-on-content-click="true"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formatedLiqPeriod"
                        :label="$t('message.LicensesManager.search.liqPeriod')"
                        append-icon="event"
                        readonly
                        v-on="on"
                        outline
                        :color="primaryColor"
                        clearable
                        @click:clear="fixDatePickerClearBug('periodoLiq')"
                        data-vs-textfield="formatedLiqPeriod"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :locale="vuetifyLocale"
                      no-title
                      type="month"
                      v-model="periodoLiq"
                      @input="menu3 = false"
                      data-vs-datepicker="periodoliq"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </template>
              <template v-if="currentTab === 'specialRequests'">
                <div>
                  <v-autocomplete
                    :key="`user-autocomplete-${currentTab}`"
                    v-model="userSelectedSpecialRequests"
                    :items="items"
                    :loading="usersLoading"
                    :search-input.sync="searchUsers"
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="id"
                    :label="$t('message.LicensesManager.search.user')"
                    :hint="$t('message.LicensesManager.search.userHint')"
                    persistent-hint
                    return-object
                    outline
                    :color="primaryColor"
                    clearable
                    data-vs-autocomplete="user"
                  ></v-autocomplete>
                </div>
              </template>
              <div class="mx-auto flex justify-center">
                <zt-button
                  class=""
                  icon="search-outline"
                  data-vs-button="search"
                  @click="searchButton"
                  >{{ $t('message.LicensesManager.search.search') }}</zt-button
                >
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="w-9/12">
        <zt-tab>
          <zt-tab-item
            @click="currentTab = 'licenses'"
            :label="
              $t('message.LicensesHistoryComponent.tabs.licenses.tabName')
            "
          >
            <SearchTable />
          </zt-tab-item>
          <zt-tab-item
          v-if="hasVPI"
            @click="currentTab = 'specialRequests'"
            :label="
              $t('message.LicensesHistoryComponent.tabs.otherRequests.tabName')
            "
          >
            <SearchSpecialRequests :user="userSelected" />
          </zt-tab-item>
        </zt-tab>
      </div>
    </div>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import Users from '@/apiClient/Users'
import { mapGetters } from 'vuex'
import moment from 'moment'
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import EmptyStateLicensesSearch from '@/components/commons/Illustrations/graphicSVG/licenseSearchEmpty'
import SearchTable from './SearchTable'
import SearchSpecialRequests from './SearchSpecialRequests.vue'
import { isEmpty } from 'lodash'

export default {
  inject: ['state', 'mutations'],
  components: {
    graphicBase,
    EmptyStateLicensesSearch,
    SearchTable,
    SearchSpecialRequests
  },
  data() {
    return {
      licenses: Licenses,
      users: Users,
      config: {},
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 8,
        sortBy: null,
        totalItems: 0
      },
      usersList: [],
      usersLoading: false,
      userSelected: {
        id: 0
      },
      userSelectedSpecialRequests: {
        id: 0
      },
      searchUsers: null,
      estados: [
        {
          id: '3',
          value: this.$t(
            'message.LicensesManager.search.statusList.pendingSupervisor'
          )
        },
        {
          id: '4',
          value: this.$t('message.LicensesManager.search.statusList.pendingHr')
        },
        {
          id: '5',
          value: this.$t('message.LicensesManager.search.statusList.approved')
        },
        {
          id: '10',
          value: this.$t('message.LicensesManager.search.statusList.cancelled')
        },
        {
          id: '8',
          value: this.$t('message.LicensesManager.search.statusList.rejected')
        },
        {
          id: '9',
          value: this.$t('message.LicensesManager.search.statusList.outdated')
        },
        {
          id: '7',
          value: this.$t('message.LicensesManager.search.statusList.assignment')
        }
      ],
      estadoSelected: '',
      licenseTypes: [],
      licenseTypeSelected: '',
      estadosUsuario: [
        {
          id: '1',
          value: this.$t('message.LicensesManager.search.userStatusActive')
        },
        {
          id: '3',
          value: this.$t('message.LicensesManager.search.userStatusUnactive')
        },
        { id: null, value: this.$t('message.LicensesManager.search.all') }
      ],
      estadoUsuarioSelected: null,
      menu1: false,
      menu2: false,
      menu3: false,
      periodoDesde: '',
      periodoHasta: '',
      periodoLiq: '',
      currentTab: 'licenses'
    }
  },
  async created() {
    this.licenses = new Licenses()
    this.users = new Users()
    await this.$store.dispatch('setConfig')
    this.config = this.$store.getters.getConfig
    this.licenses.getLicenseTypesManager().then(res => {
      this.licenseTypes = res.data.data
    })
  },
  computed: {
    totalResults() {
      return this.state.total
    },
    items() {
      return this.usersList.map(entry => {
        let fullName = `${entry.name} ${entry.last_name} (${entry.laborId})`
        const name =
          fullName.length > this.descriptionLimit
            ? fullName.slice(0, this.descriptionLimit) + '...'
            : fullName

        return Object.assign({}, entry, { name })
      })
    },
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    },
    formatedDateFrom() {
      return this.periodoDesde
        ? moment(this.periodoDesde).format('DD/MM/YYYY')
        : ''
    },
    formatedDateTo() {
      return this.periodoHasta
        ? moment(this.periodoHasta).format('DD/MM/YYYY')
        : ''
    },
    formatedLiqPeriod() {
      return this.periodoLiq ? moment(this.periodoLiq).format('MM/YYYY') : ''
    },
    ...mapGetters({
      locale: 'getLocale'
    }),
    vuetifyLocale() {
      return this.locale === 'br' ? 'pt' : 'es'
    },
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    }
  },
  watch: {
    searchUsers(val) {
      if (!val) {
        this.usersList = []
        return
      }
      if (val.length > 2) {
        if (this.usersLoading) return
        this.usersLoading = true
        this.licenses
          .searchEmployeesAssigned(val, this.currentTab === 'licenses' ? 1 : 0)
          .then(res => {
            this.usersList = res.data.data
          })
          .catch(err => {})
          .finally(() => (this.usersLoading = false))
      }
    },
    currentTab() {
      this.userSelected = { id: 0 }
      this.userSelectedSpecialRequests = { id: 0 }
      this.usersList = []
      this.searchUsers = null
    }
  },
  methods: {
    currentTabClearState() {
      this.state.results = []
    },
    searchButton() {
      if (isEmpty(this.state.pagination)) {
        this.mutations.setPagination(this.pagination)
      }
      if (this.currentTab === 'specialRequests') {
        this.mutations.setFiltersSpecialRequests({
          userId: this.userSelectedSpecialRequests
            ? this.userSelectedSpecialRequests.id
            : null
        })
        this.search()
        return
      } else {
        let filters = {
          userId: this.userSelected ? this.userSelected.id : null,
          licenseTypeId: this.licenseTypeSelected
            ? this.licenseTypeSelected.id
            : null,
          periodoDesde: this.periodoDesde,
          periodoHasta: this.periodoHasta,
          periodoLiq: this.formatedLiqPeriod,
          estadoId: this.estadoSelected ? this.estadoSelected.id : null,
          estadoUsuarioId:
            this.estadoUsuarioSelected !== null
              ? this.estadoUsuarioSelected.id
              : null
        }
        this.mutations.setFilters(filters)
        this.search()
      }
    },
    search() {
      if (this.currentTab === 'specialRequests') {
        this.licenses
          .getSpecialRequestsManager(
            this.state.filtersSpecialRequests,
            this.state.paginationSpecialRequests.rowsPerPage,
            this.state.paginationSpecialRequests.page
          )
          .then(response => {
            this.mutations.setResultsSpecialRequests(response.data.results.data)
            this.mutations.setTotalResultsSpecialRequests(
              response.data.pagination.total
            )
            this.pagination = this.state.paginationSpecialRequests
            this.pagination.totalItems = response.data.pagination.total
            this.mutations.setPaginationSpecialRequests(this.pagination)
          })
      } else {
        this.licenses
          .searchLicenses(
            this.state.filters,
            this.state.pagination.rowsPerPage,
            this.state.pagination.page
          )
          .then(response => {
            this.mutations.setResults(response.data.results.data)
            this.mutations.setTotalResults(response.data.pagination.total)
            this.pagination = this.state.pagination
            this.pagination.totalItems = response.data.pagination.total
            this.mutations.setPagination(this.pagination)
          })
      }
    },
    fixDatePickerClearBug(property) {
      switch (property) {
        case 'periodoDesde':
          this.periodoDesde = ''
          break
        case 'periodoHasta':
          this.periodoHasta = ''
          break
        case 'periodoLiq':
          this.periodoLiq = ''
          break
        default:
          break
      }
    },
    goBack() {
      this.$route.params.routerGo === 'manager'
        ? this.$router.push('/manager-licenses-page')
        : this.$router.push('/licenses-manager')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep
  .theme--light.v-text-field--outline
  > .v-input__control
  > .v-input__slot {
  border: 2px solid rgba(105, 105, 105, 0.54);
}

::v-deep
  .theme--light.v-text-field--outline
  > .v-input__control
  > .v-input__slot:hover {
  border: 2px solid #4f41a3 !important;
}

.back-button:hover {
  background-color: #e0e0e0;
  border-radius: 9999px;
}

/* Estilos para modo iframe */
.iframe-mode {
  ::v-deep .theme--light.v-text-field--outline > .v-input__control > .v-input__slot:hover {
    border: 2px solid #2694fc !important;
  }
  
  ::v-deep .v-input--is-focused .v-input__slot {
    border-color: #2694fc !important;
  }
  
  ::v-deep .v-picker__title {
    background-color: #2694fc !important;
  }
  
  ::v-deep .v-date-picker-table .v-btn.v-btn--active {
    background-color: #2694fc !important;
  }
  
  /* Botones zt-button */
  ::v-deep .zt-button {
    background-color: #2694fc !important;
    border-color: #2694fc !important;
    
    &:hover {
      background-color: #1e7fd4 !important;
      border-color: #1e7fd4 !important;
    }
  }
  
  /* Tabs zt-tab */
  ::v-deep .zt-tab-item--active {
    background-color: #2694fc !important;
    border-bottom-color: #2694fc !important;
  }
  
  ::v-deep .zt-tab-item {
    &:hover {
      background-color: rgba(38, 148, 252, 0.1) !important;
    }
  }
  
  /* Override para .child-active button - selector más específico */
  ::v-deep .zt-tab .child-active button.zt-tab--btn,
  ::v-deep .child-active button.zt-tab--btn {
    background-color: #2694fc !important;
    color: #fff !important;
    border-color: #2694fc !important;
  }
}

.text-iframe-primary {
  color: #2694fc !important;
}
</style>
